import type { RequestError } from '@swf/core/api/request';
import type { EffectParams } from '@swf/core/store';

import type { AuthError } from '.';

const pinReset = async (params: { userId: string }, { dispatch, request }: EffectParams) => {
  try {
    const { headers } = await request({
      service: '/api/v1-preview/auth/pin/remind',
      method: 'POST',
      body: params
    });
    dispatch.auth.success(headers);
  } catch (err) {
    dispatch.auth.error(err as RequestError<AuthError>);
  }
};

export default pinReset;
